import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

export const useIsEmailHubNewsletterPhaseAEnabled = (): boolean => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.email_hub_newsletter_phase_a_enabled,
  );
};
